import Api from "../utils/axios";

const OrderApi = {
  getAllOrders: (payload,search="") => Api.post(`order/get-all-orders?search=${search}`,payload),  
  updateOrders: (payload) => Api.put(`order/update-order`,payload),  
  getSingleOrder: (id) => Api.get(`order/get-order-by-id/${id}`),  
};

export const foodOrderApi = {
  getAllFoodOrders: (payload,search="") => Api.post(`food-order/get-all-orders?search=${search}`,payload),   
  updateOrders: (payload) => Api.put(`food-order/update-order`,payload),  
};

export default OrderApi;

export const reviewApi={
  getAllVendorReviews: (payload,search="") => Api.post(`order/get-all-vendor-review?search=${search}`,payload),  
  getAllProductReviews: (payload,search="") => Api.post(`order/get-all-product-review?search=${search}`,payload),  
  vendorReply: (payload, reviewId) => Api.put(`vendor/reply-to-user/${reviewId}`, payload),
  getSingleReview: (reviewId) => Api.get(`vendor/get-products-rating-review-by-id/${reviewId}`),
}